import React, { FC } from 'react';
import { CapsProps } from './CapsProps';
import Caps from '../Configuration/Financials/Pricing/Forms/Caps';

export const DefaultCaps: FC<CapsProps> =
    props => <Caps {...props} showMonetaryCaps/>;
